$(function(){
	if ($('section.bannerBottomFixed').length > 0){
		$("section.bannerBottomFixed").find(".bannerBottomFixed-close").click(function(){
			$("section.bannerBottomFixed").remove();
		});
	}
})